import { ErrorParser } from "../ErrorParser";
import { isObject } from "lodash-es";

/**
 * Ej: the block_id in question 117 does not point to a block
 */
export class BloqueNoExisteParser implements ErrorParser {
    public puedeLeerError(error: string): boolean {
        return !isObject(error) && error.includes("the block_id in question") && error.includes("does not point to a block");
    }

    public traducir(error: string): string {
        const matches = error.match(/\d+/g);
        if (matches == null || matches.length === 0) {
            return "";
        }
        return `No existe la pregunta bloque que se referencia en la pregunta ${matches[0]}`;
    }

}
